import Debug from 'debug'
const debug = Debug('app:login:reset:ctrl')

// Handle legacy password resets
// Retaining this route mainly so developers have an easy way to reset their legacy password, if needed.
// NOTE: All buttons to trigger a legacy password reset have been "removed" (modified to give different instructions)
// but a legacy password reset can still be triggered by sending a cURL request to the api-v1 password reset endpoint
class ResetController {
  /* @ngInject */
  constructor (Users, $state, $mdDialog, username, $stateParams) {
    this.username = username
    this.Users = Users
    this.authToken = $state.params.auth
    this.$state = $state
    this.$mdDialog = $mdDialog
    debug('username %o', username)
    debug('params', $state.params)
    this.passwordResetEmail = username
    this.passwordResetAuth = $stateParams.auth
    this.zipinvite = $stateParams.invite || false

    this.passwordResetTitle = 'Set Password'
    this.passwordResetButtonTitle = 'Set Password'
    this.passwordResetSuccessTitle = 'Successfully Set Password'
    console.log($state)
  }

  resetSuccess () {
    const alert = this.$mdDialog.alert({
      title: 'Successfully Sent Password reset',
      textContent: 'Please check you email and follow the link',
      ok: 'Close'
    })

    this.$mdDialog.show(alert)
  }

  resetError () {
    const alert = this.$mdDialog.alert({
      title: 'Unable to reset password',
      textContent: 'Please contact bluecrew by clicking the message icon',
      ok: 'Close'
    })

    this.$mdDialog.show(alert)
  }

  updatePassword () {
    if (!this.authToken) return debug('No auth token!')
    const data = {
      username: this.username,
      password: this.password,
      auth: this.authToken
    }

    this.Users.updatePassword(data)
      .then(this.updatePasswordSuccess.bind(this), this.resetError.bind(this))
  }

  updatePasswordSuccess () {
    const alert = this.$mdDialog.alert({
      title: 'Success',
      textContent: 'Password updated successfully',
      ok: 'Close'
    })

    this.$mdDialog.show(alert)
      .then(this.$state.go('app.login'))
  }

}

export default ResetController
